import styled from 'styled-components'
import { BaseInput, BaseMaskedInput } from 'components/Inputs/Base'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 880px;
  background-color: #F7F7F7;
  box-shadow: 0px 2px 10px -6px #252525;
  padding: 10px;
  border-radius: 15px;
  margin-bottom: 15px;
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const FormField = styled(Container)`
  flex: ${props => props.stretch ? props.stretch : 1};
  justify-content: flex-end;
  padding: 0px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  gap: 5px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  margin-bottom: 15px;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
`

export const TextRow = styled(Row)`
  align-items: center;
  margin-bottom: 2px;
  gap: 5px;

  p {
    margin: 0px;
  }
`

export const CheckRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 3px;

  label, p {
    cursor: pointer;
    margin-bottom: 1px;
  }
`

export const StepRow = styled.div`
  width: 400px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: flex-start;
  position: relative;
  margin: 10px 10px 15px;
`

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
`

export const StepLabel = styled.p`
  color: #999999;
  font-size: 11px;
  line-height: 14px;
  text-align: center;
  margin: 0px;
`

export const Circle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 99px;
  background-color: #252525;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StepCircle = styled(Circle)`
  z-index: 2;
  background-color: ${({ step, currentStep }) => (
    currentStep?.number > step?.number
      ? '#44CF6C'
      : currentStep?.number === step?.number ? '#FFC100' : '#252525'
  )};

  p {
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 1px;
  }
`

export const StepLine = styled.span`
  display: inline-block;
  position: absolute;
  top: 14px;
  left: 40px;
  width: ${({ currentStep }) => currentStep * 80}px;
  height: 3px;
  z-index: 1;
  background-color: #44CF6C;
  transition: width 0.3s;
`

export const ImageContainer = styled.button.attrs ({
  type: 'button'
})`
  width: 90px;
  display: flex;
  background-color: transparent;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: center;
  position: relative;
  margin: 5px 0px 15px;
  border: 0px;
`

export const AddressContainer = styled.div`
  width: 100%;
  position: relative;
`

export const Image = styled.img`
  width: 90px;
  height: 90px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
`

export const LoadingBackdrop = styled.div`
  position: absolute;
  top: -8px;
  left: -3px;
  width: 786px;
  height: 106px;
  background-color: #FFFFFFAA;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
`

export const Label = styled.label`
  font-size: 12px;
  text-align: center;
  color: #000000;
  margin: 0px;

  &:hover {
    cursor: pointer;
  }
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  line-height: 18px;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const WarningText = styled.p`
  margin: 3px 0px 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 200;
  line-height: 18px;
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 8px;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 15px;
  text-align: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
    margin: 0px;
  }
`

export const SmallButton = styled(LookButton).attrs(buttonLook({ variant: 'ghost' }))`
  gap: 8px;
  align-self: flex-start;
  margin-bottom: 20px;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin: 0px 5px;
`

export const MaskedInput = styled(BaseMaskedInput)`
  width: 100%;
  margin: 0px 5px;
`
